import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Button, Typography, Spin } from "antd"; // Thêm Spin cho loading
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import SideNav from "../../components/SideNav/SideNavAccount";
import { useNavigate } from "react-router-dom";
import { api, endpoints } from "../../utils/axiosInstance";

const { Title, Text } = Typography;

const PageWrapper = styled.div`
  padding: 40px;
  background-color: #f5f5f5;
  min-height: 100vh;
`;

const ContentWrapper = styled.div`
  display: flex;
  gap: 40px;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const MainContent = styled.div`
  flex: 1;
`;

const PageContainer = styled.div`
  width: 100%;
`;

const CurrentSubscriptionCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  margin-bottom: 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const PremiumCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  margin-top: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: auto 100px 100px;
  gap: 20px;
  margin-top: 30px;
`;

const FeatureRow = styled.div`
  display: contents;
  & > * {
    padding: 15px 0;
    border-bottom: 1px solid #f0f0f0;
  }
`;

const StyledButton = styled(Button)`
  background-color: #22c55e;
  color: white;
  height: 48px;
  font-size: 16px;
  border-radius: 24px;
  border: none;
  padding: 0 30px;

  &:hover {
    background-color: #16a34a !important;
    color: white !important;
  }
`;

const IconWrapper = styled.div`
  text-align: center;
`;

const GreenCheck = styled(CheckOutlined)`
  color: #22c55e;
  font-size: 20px;
`;

const RedCross = styled(CloseOutlined)`
  color: #ef4444;
  font-size: 20px;
`;

const AppleIcon = styled.div`
  width: 48px;
  height: 48px;
  background-color: #22c55e;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;

  img {
    width: 32px;
    height: 32px;
  }
`;

const LoadingWrapper = styled.div`
  text-align: center;
  padding: 20px;
  color: #666;
`;

const ManageSubscriptionPage = () => {
  const navigate = useNavigate();
  const [subscriptionTitle, setSubscriptionTitle] = useState("");
  const [loading, setLoading] = useState(true); // State để kiểm soát loading

  useEffect(() => {
    const checkSubscription = async () => {
      setLoading(true); // Bắt đầu loading
      try {
        const res = await api.get(endpoints.orders.checkSubscription);
        // Giả sử API trả về { isPremium: true/false }
        if (res.data && res.data.isPremium) {
          setSubscriptionTitle("Gói Cao Cấp MealMate");
        } else {
          setSubscriptionTitle("Gói Cơ Bản MealMate");
        }
      } catch (error) {
        console.error("Lỗi khi kiểm tra gói đăng ký:", error);
        setSubscriptionTitle("Gói Cơ Bản MealMate"); // Mặc định nếu API thất bại
      } finally {
        setLoading(false); // Kết thúc loading dù thành công hay thất bại
      }
    };

    checkSubscription();
  }, []);

  const handleViewPremium = () => {
    navigate("/payment");
  };

  // Chỉ hiển thị nội dung khi loading hoàn tất
  if (loading) {
    return (
      <PageWrapper>
        <ContentWrapper>
          <SideNav />
          <MainContent>
            <PageContainer>
              <LoadingWrapper>
                <Spin size="large" />
                <Text style={{ marginTop: 10, display: "block" }}>
                  Đang kiểm tra gói dịch vụ...
                </Text>
              </LoadingWrapper>
            </PageContainer>
          </MainContent>
        </ContentWrapper>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <ContentWrapper>
        <SideNav />
        <MainContent>
          <PageContainer>
            <Title level={1} style={{ marginBottom: 40 }}>
              Quản lý gói dịch vụ
            </Title>

            <CurrentSubscriptionCard>
              <Text
                type="secondary"
                style={{ fontSize: 16, marginBottom: 16, display: "block" }}
              >
                GÓI DỊCH VỤ HIỆN TẠI
              </Text>
              <Title level={2} style={{ margin: 0 }}>
                {subscriptionTitle}
              </Title>
              <StyledButton
                style={{ marginTop: 24 }}
                onClick={handleViewPremium}
              >
                XEM GÓI CAO CẤP
              </StyledButton>
            </CurrentSubscriptionCard>

            <PremiumCard>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 20,
                }}
              >
                <div>
                  <Title level={2} style={{ margin: 0 }}>
                    MealMate Cao Cấp
                  </Title>
                  <Text style={{ fontSize: 18 }}>
                    Truy cập đầy đủ các công cụ bạn cần để đạt được mục tiêu sức
                    khỏe
                  </Text>
                </div>
                <AppleIcon>
                  {/* You can add an apple icon image here */}
                </AppleIcon>
              </div>

              <FeatureGrid>
                <Text strong style={{ fontSize: 16 }}>
                  Tính năng
                </Text>
                <Text strong style={{ fontSize: 16, textAlign: "center" }}>
                  Cơ bản
                </Text>
                <Text strong style={{ fontSize: 16, textAlign: "center" }}>
                  Cao cấp
                </Text>

                <FeatureRow>
                  <div>
                    <Text strong>Xem các công thức nấu ăn</Text>
                    <Text style={{ display: "block", color: "#666" }}>
                      Mọi người có thể tự do xem tất cả các công thức nấu ăn
                      trong website của chúng tôi.
                    </Text>
                  </div>
                  <IconWrapper>
                    <GreenCheck />
                  </IconWrapper>
                  <IconWrapper>
                    <GreenCheck />
                  </IconWrapper>
                </FeatureRow>

                <FeatureRow>
                  <div>
                    <Text strong>Xem các thực đơn có sẵn</Text>
                    <Text style={{ display: "block", color: "#666" }}>
                      Nếu không biết hôm nay ăn gì thì bạn có thể tham khảo 1 số
                      thực đơn có sẵn của chúng tôi.
                    </Text>
                  </div>
                  <IconWrapper>
                    <GreenCheck />
                  </IconWrapper>
                  <IconWrapper>
                    <GreenCheck />
                  </IconWrapper>
                </FeatureRow>

                <FeatureRow>
                  <div>
                    <Text strong>Xem các bài viết chia sẻ từ mọi người</Text>
                    <Text style={{ display: "block", color: "#666" }}>
                      Những bài viết chất lượng nhất sẽ được đăng tải lên để mọi
                      người có thêm nhiều kiến thức về nấu nướng hoặc món ăn.
                    </Text>
                  </div>
                  <IconWrapper>
                    <GreenCheck />
                  </IconWrapper>
                  <IconWrapper>
                    <GreenCheck />
                  </IconWrapper>
                </FeatureRow>
                <FeatureRow>
                  <div>
                    <Text strong>Thiết lập thực đơn hàng ngày</Text>
                    <Text style={{ display: "block", color: "#666" }}>
                      Bạn có thể tự mình thiết lập thực đơn phù hợp với bản thân
                      .
                    </Text>
                  </div>
                  <IconWrapper>
                    <RedCross />
                  </IconWrapper>
                  <IconWrapper>
                    <GreenCheck />
                  </IconWrapper>
                </FeatureRow>
                <FeatureRow>
                  <div>
                    <Text strong>Xem lại lịch sử ăn uống</Text>
                    <Text style={{ display: "block", color: "#666" }}>
                      Để tránh gay nhàm chán khi ăn đi ăn lại 1 món và kiểm soát
                      số calo nên chúng tôi sẽ ghi lại lịch sử ăn uống của bạn
                      để giúp bạn có thể kiểm soát được.
                    </Text>
                  </div>
                  <IconWrapper>
                    <RedCross />
                  </IconWrapper>
                  <IconWrapper>
                    <GreenCheck />
                  </IconWrapper>
                </FeatureRow>
                <FeatureRow>
                  <div>
                    <Text strong>Lưu lại những món ăn yêu thích của bạn</Text>
                    <Text style={{ display: "block", color: "#666" }}>
                      Có 1 số món tủ mà k muốn đi tìm kiếm,đừng lo chức năng yêu
                      thích sẽ giúp bạn giải quyết điều đó.
                    </Text>
                  </div>
                  <IconWrapper>
                    <RedCross />
                  </IconWrapper>
                  <IconWrapper>
                    <GreenCheck />
                  </IconWrapper>
                </FeatureRow>
              </FeatureGrid>
            </PremiumCard>
          </PageContainer>
        </MainContent>
      </ContentWrapper>
    </PageWrapper>
  );
};

export default ManageSubscriptionPage;
